"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_map_sdk_1 = require("@xenodrive/vue-map-sdk");
exports.default = (0, vue_map_sdk_1.useMapSDK)({
    baseLayers: ['emap:flat'],
    baseLayerOverrides: {
        'emap:flat': {
            minZoom: 4,
        },
    },
    emapOptions: {
        test: true,
        loader: false,
    },
    sprites: {
        defaults: {
            src: '/assets/img/movement/sprite.png',
            srcSize: [512, 512],
            icons: {
                icon_vehicle_1_1: [0, 0, 50, 50, 0.5, 0.4],
                icon_vehicle_1_1_n: [50, 0, 50, 50],
                icon_vehicle_1_2: [100, 0, 50, 50, 0.5, 0.4],
                icon_vehicle_1_2_n: [150, 0, 50, 50],
                icon_vehicle_2: [200, 0, 50, 50],
                icon_vehicle_3: [250, 0, 50, 50],
                icon_vehicle_4: [300, 0, 50, 50],
                icon_vehicle_5: [350, 0, 50, 50],
                icon_vehicle_6: [0, 50, 50, 50],
                icon_vehicle_9: [50, 50, 50, 50],
                icon_vehicle_11: [100, 50, 50, 50],
                icon_vehicle_12: [150, 50, 50, 50],
                icon_vehicle_21_1: [200, 50, 50, 50, 0.5, 0.4],
                icon_vehicle_21_1_n: [250, 50, 50, 50],
                icon_vehicle_21_2: [300, 50, 50, 50, 0.5, 0.4],
                icon_vehicle_21_2_n: [350, 50, 50, 50],
                icon_vehicle_31_1: [0, 100, 50, 50, 0.5, 0.4],
                icon_vehicle_31_1_n: [50, 100, 50, 50],
                icon_vehicle_31_2: [100, 100, 50, 50, 0.5, 0.4],
                icon_vehicle_31_2_n: [150, 100, 50, 50],
                icon_vehicle_88_1: [200, 100, 50, 50, 0.5, 0.4],
                icon_vehicle_88_2: [250, 100, 50, 50, 0.5, 0.4],
                icon_vehicle_89_1: [300, 100, 50, 50, 0.5, 0.4],
                icon_vehicle_89_2: [350, 100, 50, 50, 0.5, 0.4],
                icon_vehicle_99: [0, 150, 50, 50],
                icon_vehicle_999: [50, 150, 50, 50],
                icon_vehicle_2111: [100, 150, 50, 50],
                icon_vehicle_2112: [150, 150, 50, 50],
                icon_vehicle_2131_1: [200, 150, 50, 50, 0.5, 0.4],
                icon_vehicle_2131_1_n: [250, 150, 50, 50],
                icon_vehicle_2131_2: [300, 150, 50, 50, 0.5, 0.4],
                icon_vehicle_2131_2_n: [350, 150, 50, 50],
                arrow_blue: [0, 200, 50, 50],
                arrow_green: [50, 200, 50, 50],
                arrow_red: [100, 200, 50, 50],
                icon_destination_1: [0, 250, 50, 50],
                icon_destination_2: [50, 250, 50, 50],
                icon_destination_3: [100, 250, 50, 50],
                icon_destination_4: [150, 250, 50, 50],
                icon_destination_5: [200, 250, 50, 50],
                icon_event_default: [0, 300, 50, 50, 0.5, 0.8],
                icon_event_regular: [50, 300, 50, 50, 0.5, 0.8],
                icon_event_shoot: [100, 300, 50, 50, 0.5, 0.8],
                icon_event_warning: [150, 300, 50, 50, 0.5, 0.8],
                icon_event_work: [200, 300, 50, 50, 0.5, 0.8],
            },
        },
    },
});
